import React from 'react';
import { connect } from 'react-redux';
import { generateFakeCourse } from '../../../actions/courses';
import { withRouter } from 'react-router-dom';
import { generateFakeEnrolledTeachingPeriods } from '../../../actions/enrolledTeachingPeriods';
import Loading from '../../pages/Loading';
import {
  getDefaultFilterOptions,
  loadFilterOptions
} from '../../../services/liveview';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    submitFakeCourse: (
      admissionCategory,
      courseAttemptStatus,
      teachingPeriods = [],
      orgUnit,
      campus
    ) => {
      const courseCode = 'FAKE_COURSE_ID';

      return dispatch(
        generateFakeCourse({
          courseCode: courseCode,
          admissionCategory: admissionCategory,
          courseAttemptStatus: courseAttemptStatus,
          orgUnit: orgUnit,
          locationCd: campus
        })
      ).then(() => {
        return dispatch(
          generateFakeEnrolledTeachingPeriods(courseCode, teachingPeriods)
        );
      });
    }
  };
};

class LoadStudentProfileTool extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultFilterOptions: getDefaultFilterOptions(),
      filtersApplied: false
    };
  }

  componentDidMount() {
    if (!this.state.filtersApplied) {
      const filterOptions = loadFilterOptions();

      if (filterOptions != null) {
        this.applyFilterOptions(filterOptions);
      } else {
        this.applyFilterOptions(this.state.defaultFilterOptions);
      }
    }
  }

  applyFilterOptions = filterOptions => {
    this.props
      .submitFakeCourse(
        filterOptions.admissionCategory,
        filterOptions.courseAttemptStatus,
        filterOptions.teachingPeriods,
        filterOptions.college,
        filterOptions.campus
      )
      .then(() => {
        this.setState({
          filtersApplied: true
        });
      });
  };

  render() {
    if (!this.state.filtersApplied) {
      return <Loading />;
    }

    return this.props.children;
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoadStudentProfileTool)
);
